import axiosClient from "utils/api";
const URI = "/admin/category";

export const getReportCategory = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get All Report Category:", error);
    throw error;
  }
};

export const deleteReportCategory = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete ReportCategory:", error);
    throw error;
  }
};

export const updateReportCategory = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update ReportCategory:", error);
    throw error;
  }
};

export const addReportCategory = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add ReportCategory:", error);
    throw error;
  }
};

export const updateDefaultReportCategory = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/default/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update ReportCategory:", error);
    throw error;
  }
};
